import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFilter } from "../../hooks";
import { sendStaffAppMetaData } from "../../eventTriggers";

export const PublicBenefits = () => {
  const { public_benefits, config } = useSelector((state) => state);
  const [filter, setFilter, Input] = useFilter();
  const dispatch = useDispatch();

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "publicBenefit",
        resource,
      },
    });
    sendStaffAppMetaData(
      config.tab_default_meta_data.find(
        (tab) => tab.detail == "public_benefits"
      ).modal
    );
  }

  return (
    <>
      <Input {...{ filter, setFilter }} />
      {public_benefits
        .filter((public_benefit) =>
          public_benefit.benefit_type
            .toLowerCase()
            .includes(filter.toLowerCase())
        )
        .map((public_benefit) => (
          <div
            key={public_benefit.id}
            onClick={() => handleClick(public_benefit)}
            className="p-4 border-bottom clickable"
          >
            <div className="d-flex justify-content-between align-items-center">
              <b>{public_benefit.benefit_type}</b>
            </div>
            <div className="text-secondary pt-1">{public_benefit.status}</div>
          </div>
        ))}
    </>
  );
};
